'use client'
import { SbBlokData, storyblokEditable } from '@storyblok/react/rsc'
import { FC } from 'react'

import { PhnxTestimonies } from './Testimonies'
import { TestimoniesProps } from './Testimonies'

interface TestimoniesBlokProps {
  blok: {
    title: TestimoniesProps['title']
    variant: TestimoniesProps['variant']
    items: SbBlokData[]
  } & SbBlokData
}

const Testimonies: FC<TestimoniesBlokProps> = ({ blok }) => {
  let itemsArray: any = []

  if (blok.items) {
    {
      ;(blok.items as TestimoniesProps['items']).map((item) =>
        itemsArray.push({
          variant: item.variant,
          description: item.description,
          author: item.author,
          company: item.company,
          asset: {
            src: item.asset ? item.asset?.filename : '',
            alt: item.asset ? item.asset?.alt : '',
            focus: item.asset ? item.asset?.focus : '',
          },
        })
      )
    }
  }

  return (
    <div {...storyblokEditable(blok)}>
      <PhnxTestimonies title={blok.title} variant={blok.variant} items={itemsArray} />
    </div>
  )
}

export default Testimonies
